import React from 'react';

import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';
import Heading from '@marvelapp/marvel-ui/heading';
import Align from '@marvelapp/marvel-ui/align';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';

import Wifi from 'marketing-website/components/icons/Wifi';
import Camera from 'marketing-website/components/icons/Camera';
import Sync from 'marketing-website/components/icons/Sync';
import Watch from 'marketing-website/components/icons/Watch';
import Hammer from 'marketing-website/components/icons/Hammer';
import TV from 'marketing-website/components/icons/TV';

import styles from './style/general.module.css';

export default function Features() {
  const features = [
    {
      id: 0,
      name: 'Take photos of sketches',
      description:
        'Go from a napkin sketch to a fully functional prototype in minutes',
      icon: (
        <div className={styles.fillMarvel}>
          <Camera />
        </div>
      ),
    },
    {
      id: 1,
      name: 'Build prototypes',
      description: 'Create beautifully presented desktop and mobile prototypes',
      icon: (
        <div className={styles.fillPurple}>
          <Hammer />
        </div>
      ),
    },
    {
      id: 2,
      name: 'Offline Prototypes',
      description:
        'Pre-download all your prototypes and view them with no internet connection',
      icon: (
        <div className={styles.fillTeal}>
          <Wifi />
        </div>
      ),
    },
    {
      id: 3,
      name: 'Sync from Sketch',
      description:
        'Seamlessly import prototypes and sync artboards from Sketch into Marvel',
      icon: (
        <div className={styles.fillOrange}>
          <Sync />
        </div>
      ),
    },
    {
      id: 4,
      name: 'Apple TV',
      description:
        'Marvel lets you play and preview all your prototypes on the Apple TV',
      icon: (
        <div className={styles.fillYellow}>
          <TV />
        </div>
      ),
    },
    {
      id: 5,
      name: 'Apple Watch',
      description: 'View your prototypes directly on the Apple Watch',
      icon: (
        <div className={styles.fillGreen}>
          <Watch />
        </div>
      ),
    },
  ];

  const featuresItems = features.map(feature => (
    <GridItem columnSpan={3} columnSpanM={1} key={feature.id}>
      <Align type="center">
        <Spacing size="s" type="padding" position="topBottom">
          <MaxWidth value={320}>
            <div>{feature.icon}</div>
            <Spacing size="m" type="padding" position="top">
              <Heading tag="h3" weight="semibold" size="xl">
                {feature.name}
              </Heading>
            </Spacing>
            <Spacing size="s" type="padding" position="topBottom">
              <Paragraph>{feature.description}</Paragraph>
            </Spacing>
          </MaxWidth>
        </Spacing>
      </Align>
    </GridItem>
  ));

  return (
    <PageWrap size="l">
      <Align type="center">
        <MaxWidth value={920}>
          <Spacing size="xl" type="padding" position="topBottom">
            <Align type="center">
              <Grid columns={3} size="l">
                {featuresItems}
              </Grid>
            </Align>
          </Spacing>
        </MaxWidth>
      </Align>
    </PageWrap>
  );
}



// WEBPACK FOOTER //
// ./src/pages/apps/Features.js